import TopupResource from "./topup.resource";

const topupModule = angular
  .module("app.resources.topup", [])
  .service("Topup", TopupResource);

export default topupModule;



// WEBPACK FOOTER //
// ./src/resources/topup/topup.module.js